import { render, staticRenderFns } from "./resetPasswords.vue?vue&type=template&id=3d90590a&scoped=true"
import script from "./resetPasswords.vue?vue&type=script&lang=js"
export * from "./resetPasswords.vue?vue&type=script&lang=js"
import style0 from "./resetPasswords.vue?vue&type=style&index=0&id=3d90590a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d90590a",
  null
  
)

export default component.exports